<template>
  <div class="content-custom-pj" v-if="this.$store.get('systems@ApiKey')">
    <div>
      <h4><v-icon name="edit" class="icon-custom1"></v-icon> Round Ward</h4>
      <div>
        <DoctorSumWard></DoctorSumWard>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";
import DoctorSumWard from "@/components/IPDs/RoundWard/DoctorSumWard";

@Component({
  components: {
    store,
    axios,
    thaiDatetime,
    pjFunctions,
    DoctorSumWard
  },
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },

      sortBy: "numbers",
      sortDesc: true
    };
  },
  mounted() {},
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {},
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    }
  }
})
export default class RoundWard extends Vue {}
</script>


<style lang="scss">
</style>
